import { render, staticRenderFns } from "./NotificationEntry.vue?vue&type=template&id=c641ab04&"
import script from "./NotificationEntry.vue?vue&type=script&lang=ts&"
export * from "./NotificationEntry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports